import React from 'react';
import Button from '../../Components/UI/Button';
import { FiAlertTriangle } from 'react-icons/fi';
import classes from './AreYouSureModal.module.css';
import { Modal } from 'react-bootstrap';

const AreYouSureModal = ({
  show,
  setShow,
  icon,
  title,
  subTitle,
  onClick,
  isApiCall,
  alignContent = 'center'
}) => {
  return (
    <>
      <style jsx>{`
        .modal-content {
          width: 100%;
          border-radius: 20px;
          overflow: hidden;
          padding: 20px;
        }
        .modal-header {
          flex-direction: column;
          border-bottom: none;
          padding: 0px;
        }
      `}</style>
      <Modal show={show} onHide={setShow} centered>
        <Modal.Header>
          <div className={[classes.headerDiv].join(' ')}>
            {icon ? icon : <FiAlertTriangle size={100} color={'var(--warning-color)'} />}
            {title && <h2 className={[classes.headingText].join(' ')}>{title}</h2>}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.content}>
            <div className={classes.mainDiv}>
              <p className={[classes.message].join(' ')}>{subTitle}</p>
            </div>
            <div className={classes.btnsBox}>
              <Button
                variants="cancel"
                onClick={() => setShow(false)}
                disabled={isApiCall}
                className={classes.cancelBtn}>
                {isApiCall ? 'Wait' : 'Cancel'}
              </Button>
              <Button
                variants="confirm"
                className={classes.confirmBtn}
                onClick={onClick}
                disabled={isApiCall}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AreYouSureModal;
